"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListaPesquisavelEntidades = exports.buscarEntidades = void 0;
var react_1 = __importStar(require("react"));
var Icone_1 = require("../Icone/Icone");
var Botao_1 = require("../Botao/Botao");
var Divider_1 = require("../Divider/Divider");
var Paginacao_1 = require("../Paginacao/Paginacao");
var Corpo_1 = require("../Tipografia/Corpo/Corpo");
var Cores_1 = require("../Cores/Cores");
var globalMu_1 = __importDefault(require("../../globalMu"));
var RadioGrupo_1 = require("../Inputs/RadioButton/RadioGrupo/RadioGrupo");
var RadioButton_1 = require("../Inputs/RadioButton/RadioButton");
var Pesquisa_1 = require("../Inputs/Pesquisa/Pesquisa");
var Checkbox_1 = require("../Checkbox/Checkbox");
var estiloListaPesquisavelEntidades = require("./ListaPesquisavelEntidades.module.scss");
var buscarEntidades = function (entidades, termoPesquisa) {
    if (!termoPesquisa || termoPesquisa.trim() === "") {
        return entidades;
    }
    var termoNormalizado = termoPesquisa.toLowerCase().trim();
    return entidades.filter(function (entidade) {
        var _a, _b, _c;
        var nomeMatch = (_a = entidade.nome) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(termoNormalizado);
        var tipoMatch = (_b = entidade.tipo) === null || _b === void 0 ? void 0 : _b.toLowerCase().includes(termoNormalizado);
        var codigoMatch = (_c = entidade.codigo) === null || _c === void 0 ? void 0 : _c.toLowerCase().includes(termoNormalizado);
        var numeroMatch = entidade.numero !== undefined && entidade.numero !== null
            ? String(entidade.numero).toLowerCase().includes(termoNormalizado)
            : false;
        return nomeMatch || tipoMatch || codigoMatch || numeroMatch;
    });
};
exports.buscarEntidades = buscarEntidades;
var ListaPesquisavelEntidades = function (_a) {
    var entidades = _a.entidades, _b = _a.termoPesquisa, termoPesquisa = _b === void 0 ? "" : _b, quantidadePorPagina = _a.quantidadePorPagina, paginaAtual = _a.paginaAtual, quantidadeTotalItens = _a.quantidadeTotalItens, opcoesItensPorPagina = _a.opcoesItensPorPagina, _c = _a.tipoEntidade, tipoEntidade = _c === void 0 ? "Vendedor Ou Filial" : _c, barraPesquisaProps = _a.barraPesquisaProps, filtrarSessaoConfigurada = _a.filtrarSessaoConfigurada, onChangeFiltrarSessaoConfigurada = _a.onChangeFiltrarSessaoConfigurada, onChangeEntidade = _a.onChangeEntidade, onChangePagina = _a.onChangePagina, onChangeQuantidadePorPagina = _a.onChangeQuantidadePorPagina, onChangeTermoPesquisa = _a.onChangeTermoPesquisa, onAbrirModal = _a.onAbrirModal;
    var entidadesFiltradas = (0, react_1.useMemo)(function () {
        return (0, exports.buscarEntidades)(entidades, termoPesquisa);
    }, [entidades, termoPesquisa]);
    var totalItens = quantidadeTotalItens !== null && quantidadeTotalItens !== void 0 ? quantidadeTotalItens : entidadesFiltradas.length;
    var handleTermoPesquisaChange = function (novoTermo) {
        if (onChangeTermoPesquisa) {
            var termo = "";
            if (Array.isArray(novoTermo)) {
                termo = novoTermo.join(" ");
            }
            else if (typeof novoTermo === "string") {
                termo = novoTermo;
            }
            onChangeTermoPesquisa(termo);
        }
    };
    var radioOpcoes = (react_1.default.createElement("div", { className: estiloListaPesquisavelEntidades.radioOpcoes },
        react_1.default.createElement(RadioGrupo_1.RadioGrupo, null,
            react_1.default.createElement(RadioButton_1.RadioButton, { valor: "VENDEDOR", valorRadioGrupo: tipoEntidade, radioGrupo: "entidade", onChange: function () {
                    onChangeEntidade(tipoEntidade === "VENDEDOR"
                        ? "Vendedor Ou Filial"
                        : "VENDEDOR");
                } },
                react_1.default.createElement(Corpo_1.Corpo, { cor: Cores_1.Cores.TextoPadrao.CinzaMU600, tipo: "body2", negrito: 500, onClick: function () {
                        onChangeEntidade(tipoEntidade === "VENDEDOR"
                            ? "Vendedor Ou Filial"
                            : "VENDEDOR");
                    } }, "Vendedor")),
            react_1.default.createElement(RadioButton_1.RadioButton, { valor: "FILIAL", valorRadioGrupo: tipoEntidade, radioGrupo: "entidade", onChange: function () {
                    onChangeEntidade(tipoEntidade === "FILIAL"
                        ? "Vendedor Ou Filial"
                        : "FILIAL");
                } },
                react_1.default.createElement(Corpo_1.Corpo, { cor: Cores_1.Cores.TextoPadrao.CinzaMU600, tipo: "body2", negrito: 500, onClick: function () {
                        onChangeEntidade(tipoEntidade === "FILIAL"
                            ? "Vendedor Ou Filial"
                            : "FILIAL");
                    } }, "Filial")))));
    return (react_1.default.createElement("div", { className: estiloListaPesquisavelEntidades.container },
        react_1.default.createElement("div", { style: { padding: "1rem", display: "flex", alignItems: "center", gap: "1rem" } },
            react_1.default.createElement(Corpo_1.Corpo, { tipo: "body2", negrito: 700, cor: Cores_1.Cores.GradacaoNeutros.CinzaFillMU600 }, "Selecione o Tipo de Configura\u00E7\u00E3o: "),
            radioOpcoes),
        tipoEntidade !== "Vendedor Ou Filial" && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { style: { padding: "1rem" } },
                react_1.default.createElement(Checkbox_1.Checkbox, { id: "checkbox-filtrar-enntidades-com-sessao", checked: filtrarSessaoConfigurada, onChange: function (event) { return onChangeFiltrarSessaoConfigurada(event.target.checked); } },
                    react_1.default.createElement(Corpo_1.Corpo, { cor: Cores_1.Cores.TextoPadrao.CinzaMU600, tipo: "body2", negrito: 500, onClick: function () {
                            onChangeEntidade(tipoEntidade === "FILIAL"
                                ? "Vendedor Ou Filial"
                                : "FILIAL");
                        } }, "Filtrar com sess\u00E3o configurada"))),
            react_1.default.createElement("div", { style: { padding: "1rem" } },
                react_1.default.createElement(Pesquisa_1.Pesquisa
                // {...barraPesquisaProps}
                , { 
                    // {...barraPesquisaProps}
                    possuiMenu: false, placeholder: "Buscar Entidades...", valorInicial: termoPesquisa, onChangePesquisa: handleTermoPesquisaChange, onChange: handleTermoPesquisaChange, onSubmit: handleTermoPesquisaChange, tamanho: "medium", botaoDeLimpar: true, opcoesMenu: [], regraTexto: function (valor) { return valor; } })),
            react_1.default.createElement("div", null, entidadesFiltradas.map(function (entidade) {
                var numeroEntidade = entidade.numero
                    ? globalMu_1.default.formatarTelefone(String(entidade.numero))
                    : "Sem número vinculado.";
                return (react_1.default.createElement(react_1.default.Fragment, { key: entidade.codigo },
                    react_1.default.createElement("div", { className: estiloListaPesquisavelEntidades.item },
                        react_1.default.createElement(Corpo_1.Corpo, { tipo: "label1", cor: Cores_1.Cores.GradacaoNeutros.CinzaFillMU600, negrito: 700 }, entidade.nome),
                        react_1.default.createElement("div", { className: estiloListaPesquisavelEntidades.contatoEQrCode },
                            react_1.default.createElement(Corpo_1.Corpo, { tipo: "body3", cor: Cores_1.Cores.GradacaoNeutros.CinzaFillMU600, negrito: 400 }, numeroEntidade),
                            react_1.default.createElement(Botao_1.Botao, { tamanho: "small", estilo: "text", style: {
                                    backgroundColor: "#F3F3F3",
                                    padding: ".5rem",
                                }, onClick: function () {
                                    return onAbrirModal &&
                                        onAbrirModal(true, entidade);
                                } },
                                react_1.default.createElement(Icone_1.Icone, { nome: "edit", largura: "1.3rem" })))),
                    react_1.default.createElement(Divider_1.Divider, null)));
            })),
            react_1.default.createElement("div", null,
                react_1.default.createElement(Paginacao_1.Paginacao, { totalItens: totalItens, itensPorPagina: quantidadePorPagina, paginaAtual: paginaAtual, onItensPorPaginaChange: onChangeQuantidadePorPagina, onPageChange: onChangePagina, opcoesItensPorPagina: opcoesItensPorPagina }))))));
};
exports.ListaPesquisavelEntidades = ListaPesquisavelEntidades;
